module.exports = __webpack_public_path__ + "static/media/07012019003.e5152609.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/07012019003.png
// module id = 250
// module chunks = 0